(async () => {
  const el = document.getElementById('lpu-page')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/[town-translit]/lpu/[lpu-translit]/index/index.vue'),
    },
  ]

  await clientRender({ components })
})()
